import { render, staticRenderFns } from "./SVGSelect.vue?vue&type=template&id=5ec8d32a&scoped=true&"
import script from "./SVGSelect.vue?vue&type=script&lang=js&"
export * from "./SVGSelect.vue?vue&type=script&lang=js&"
import style0 from "./SVGSelect.vue?vue&type=style&index=0&id=5ec8d32a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ec8d32a",
  null
  
)

export default component.exports